<template>
  <div class="w-full p-8 gap-4 flex flex-col bg-[#F1F1F1]">
    <div
      ref="header"
      class="w-full gap-2 flex flex-col items-center justify-center text-center"
    >
      <span class="text-3xl font-bold text-gray-900">{{
        $t('auth.login.title')
      }}</span>
      <!-- <span class="text-[#7C7C7C] leading-5">
        Введіть свою електронну адресу
      </span> -->
    </div>

    <BaseForm ref="form" class="mt-4 gap-4 flex flex-col">
      <BaseFormField
        :value="form.email"
        :rules="[$rules.required, $rules.email, v => $rules.counter(v, 50)]"
      >
        <template #default="{ errors }">
          <BaseInput
            v-model="form.email"
            type="email"
            icon="at"
            :placeholder="$t('auth.login.emailPlaceholder')"
            :errors="errors"
          />
        </template>
      </BaseFormField>

      <span v-if="error" class="text-error text-center">
        {{ error.message }}
      </span>
    </BaseForm>

    <div class="flex flex-col">
      <BaseButton
        class="w-full"
        :is-disabled="!form.email || isLoadingGoogle"
        :is-loading="isLoading"
        @click="handleSubmit"
      >
        {{ $t('auth.login.loginWithEmail') }}
      </BaseButton>

      <BaseButton
        class="mt-4"
        color="transparent"
        size="small"
        @click="handleOpenRegistration"
      >
        {{ $t('auth.login.createNewAccount') }}
      </BaseButton>

      <div class="relative my-8 flex items-center justify-center">
        <span class="absolute px-2 text-sm text-[#999] bg-[#F1F1F1]">{{
          $t('auth.login.or')
        }}</span>
        <div class="w-full h-px bg-[#D1D1D1]"></div>
      </div>

      <BaseButton
        class="w-full"
        variant="secondary"
        :is-disabled="isLoading"
        :is-loading="isLoadingGoogle"
        @click="$emit('google-sign-in')"
      >
        <div class="gap-4 flex items-center justify-center">
          <img src="/icons/google-logo.png" alt="Google" class="w-6 h-6" />
          {{ $t('auth.login.loginWithGoogle') }}
        </div>
      </BaseButton>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import * as services from '@/services'

import BaseForm from '@/components/Base/BaseForm/BaseForm.vue'
import BaseFormField from '@/components/Base/BaseForm/BaseFormField.vue'
import BaseInput from '@/components/Base/BaseInput.vue'
import BaseButton from '@/components/Base/BaseButton.vue'

export default {
  name: 'AuthLogin',

  components: { BaseForm, BaseFormField, BaseInput, BaseButton },

  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    isLoadingGoogle: {
      type: Boolean,
      default: false
    },
    error: {
      type: Object,
      default: null
    }
  },

  data: () => ({
    form: {
      email: ''
    }
  }),

  computed: {
    ...mapGetters('locale', ['currentLocale'])
  },

  methods: {
    handleOpenRegistration() {
      this.$emit('open-registration')
    },

    async handleSubmit() {
      this.$gtag.event('auth_login_submitted')

      const isValid = this.defineIsValid()

      if (!isValid) return

      this.$emit('update:isLoading', true)
      const { isSuccess, error } = await services.auth.generateOtp({
        email: this.form.email,
        locale: this.currentLocale
      })
      this.$emit('update:isLoading', false)

      if (error) {
        this.$emit('update:error', error)
      }

      if (!isSuccess) {
        if (error.code === 'AUTH_NO_USER_TRY_REGISTER') {
          this.$router.replace({
            query: { email: this.form.email }
          })
          this.$emit('open-registration')
          return
        }
      }

      this.$gtag.event('auth_login_success')
      this.$emit('open-code', { email: this.form.email })
    },

    defineIsValid() {
      return this.$refs.form.defineIsValid()
    }
  }
}
</script>
